"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadLinkedLine = void 0;
const factories_1 = require("../../factories");
const loadLinkedLine = async (supabase, id) => {
    const results = await factories_1.OrderRequestFactory.getOrderLinkedLineById(supabase, id).then((res) => {
        // if result is PostgrestError, then handle it
        if (res === undefined) {
            return null;
        }
        else {
            const c = res;
            return c;
        }
    });
    return results;
};
exports.loadLinkedLine = loadLinkedLine;
